var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'src/utils/common';
import { Link } from 'react-router-dom';
import { includes, uniq } from 'lodash';
import * as classNames from 'classnames';
import { matchPath } from 'react-router';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Drawer, Icon, List, ListItem, ListSubheader, Avatar, Typography, Tooltip } from '@material-ui/core';
import BetaBadge from './BetaBadge';
import { QueryS3Url } from './QueryS3Url';
import { isLPUser } from 'src/utils/common';
import { getInitials } from 'src/utils/common';
import { getTranslation } from '../../translation';
import { getTubeData } from 'src/gql/queries/getTube';
import { SIDEBAR_WIDTH } from 'src/constants/common';
import { listTracksData } from 'src/gql/queries/listTracks';
import { listChannelsData } from 'src/gql/queries/listChannels';
import { getUserFollowData } from 'src/gql/queries/getUserFollowData';
import { isTasksFeatureEnabled, isNotificationsFeatureEnabled, isChatFeatureEnabled } from 'src/utils/featureFlagChecks';
import { isCurrentPageAdminOrUserTasksPage, isCurrentPageNotificationPage } from 'src/utils/common';
import { toggleSidebar, updateScrollPosition, toggleSubscriptionsMenu, toggleTracksExpandMenu, } from '../../store/actions';
var styles = function (theme) { return ({
    drawer: {
        '& > div': {
            borderRight: 0,
        },
        '@media(max-width: 1024px)': {
            display: 'none',
        },
    },
    sidebar: {
        overflowY: 'overlay',
        '&:hover': {
            '&::-webkit-scrollbar': {
                width: 8,
                position: 'fixed',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        '&::-webkit-scrollbar': {
            backgroundColor: 'transparent',
            width: 0,
        },
        height: '100vh',
        backgroundColor: '#303030',
    },
    navigation: {
        height: 65,
        padding: '15px 20px',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
    },
    backIcon: {
        color: 'white',
        marginTop: 5,
        cursor: 'pointer',
        marginLeft: 172,
        marginBottom: 9,
    },
    header: {
        position: 'relative',
    },
    hamburgerWrapper: {
        paddingLeft: 20,
        paddingRight: 5,
    },
    hamburger: {
        cursor: 'pointer',
    },
    text: {
        marginLeft: 42,
        lineHeight: '14.5px',
        fontWeight: 400,
        color: 'white',
    },
    name: {
        fontSize: 16,
    },
    email: {
        'white-space': 'nowrap',
        marginTop: 8,
        fontSize: 13,
        opacity: 0.5,
    },
    photo: {
        backgroundColor: '#303030',
        padding: 8,
        height: 72,
        width: 72,
        overflow: 'hidden',
        position: 'absolute',
        bottom: -30,
        left: 137,
        borderRadius: '50%',
        transform: 'translateX(-50%)',
        '& > img': {
            borderRadius: '50%',
        },
    },
    heading: {
        'text-transform': 'uppercase',
        color: 'rgb(96, 96, 96)',
        fontSize: 14,
        lineHeight: '48px',
        fontWeight: 500,
    },
    headingPadding: {
    // paddingTop: 20,
    },
    item: {
        color: 'rgb(3,3,3) !important',
        textDecoration: 'none !important',
    },
    content: {},
    userHeader: {
        color: 'white !important',
    },
    userColumn: {
        color: 'white !important',
        paddingLeft: '20px !important',
    },
    mobileHidden: {
        '@media(max-width: 1024px)': {
            display: 'none',
        },
    },
    showMoreButtonWrapper: {
        cursor: 'pointer',
        color: 'rgb(3,3,3)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        marginTop: 5,
        marginBottom: 5,
    },
    menuText: {
        fontWeight: 400,
        fontSize: 14,
    },
    channelPreloader: {
        width: 22,
        height: 23,
        marginRight: 10,
        maxWidth: '100%',
        backgroundColor: '#cccccc',
    },
    groupSeparator: {
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '8px 0',
    },
    channelSubscriptionWrapper: {
        width: 280,
        '&:hover': {
            backgroundColor: '#F2F2F2',
        },
        '@media(max-width: 1305px)': {
            width: 245,
        },
    },
    selectedChannelSubscriptionWrapper: {
        width: 280,
        backgroundColor: '#E5E5E5',
        '&:hover': {
            backgroundColor: '#D9D9D9',
        },
        '@media(max-width: 1305px)': {
            width: 245,
        },
    },
    logo: {
        paddingLeft: 14,
        paddingTop: 5,
        maxHeight: 51,
    },
    menuClass: {
        color: 'rgba(96,96,96)',
        marginRight: 10,
    },
    topNavImg: {
        color: 'rgba(96,96,96)',
        marginRight: 10,
        width: 23,
        height: 23,
    },
    subscriptionItem: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'flex',
        textDecoration: 'none !important',
    },
    channelImg: {
        marginRight: 10,
        width: 22,
        height: 23,
        display: 'flex',
        position: 'relative',
        fontSize: '1rem',
        justifyContent: 'center',
    },
    channelText: {
        marginTop: 2,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    topNavItem: {
        width: '100%',
        display: 'flex',
        padding: '12px 24px',
        textDecoration: 'none !important',
        '&:hover': {
            backgroundColor: '#F2F2F2',
            color: 'rgb(3,3,3)',
        },
    },
    selectedTopNavItem: {
        width: '100%',
        display: 'flex',
        padding: '12px 24px',
        backgroundColor: '#E5E5E5',
        fontWeight: 500,
        textDecoration: 'none !important',
        '&:hover': {
            backgroundColor: '#D9D9D9',
            color: 'rgb(3,3,3)',
        },
    },
    topOptions: {
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        paddingBottom: 8,
    },
    topNavText: {
        color: 'rgb(3,3,3)',
        marginTop: 3,
    },
    menuContainer: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        height: 56,
    },
}); };
var TRACKS_TO_SHOW_BEFORE_EXPAND = 5;
var Item = function (_a) {
    var classes = _a.classes, item = _a.item, translate = _a.translate, isBeta = _a.isBeta;
    var Comp = (React.createElement(Link, { id: item.id, name: item.name, to: item.linkTo, className: classes.item }, item.name));
    return (React.createElement(ListItem, { button: true, className: item.linkTo === '/admin/reports' || item.linkTo === '/admin/users' ? classes.mobileHidden : '' }, isBeta ? React.createElement(BetaBadge, { badgeContent: translate('beta') }, Comp) : Comp));
};
var MenuItemWithIcon = function (text, iconName, routeTo, id, isPageSelected, classes, tubeColor) { return (React.createElement(Link, { id: id, name: text, to: routeTo, className: !isPageSelected ? classes.topNavItem : classes.selectedTopNavItem },
    React.createElement(Icon, { style: isPageSelected ? { color: tubeColor } : {}, className: classes.topNavImg }, iconName),
    React.createElement("span", { className: classes.topNavText }, text))); };
var Content = function (_a) {
    var tubeId = _a.tubeId, classes = _a.classes, listTags = _a.listTags, isLPUser = _a.isLPUser, orgId = _a.orgId, listUsers = _a.listUsers, translate = _a.translate, tubeColor = _a.tubeColor, listVideos = _a.listVideos, listTracks = _a.listTracks, followBeta = _a.followBeta, isPersistent = _a.isPersistent, getTubeQuery = _a.getTubeQuery, currentPath = _a.currentPath, originalOrgId = _a.originalOrgId, listAzureAd = _a.listAzureAd, listChannels = _a.listChannels, listBranding = _a.listBranding, onPageChange = _a.onPageChange, onCloseSidebar = _a.onCloseSidebar, listTracksQuery = _a.listTracksQuery, followingFeature = _a.followingFeature, listChannelsQuery = _a.listChannelsQuery, updateOrganization = _a.updateOrganization, listClassification = _a.listClassification, setTracksExpandMenu = _a.setTracksExpandMenu, videoProcessingBeta = _a.videoProcessingBeta, isTracksMenuExpanded = _a.isTracksMenuExpanded, isTasksFeatureEnabled = _a.isTasksFeatureEnabled, isChatFeatureEnabled = _a.isChatFeatureEnabled, isNotificationsFeatureEnabled = _a.isNotificationsFeatureEnabled, setSubscriptionsMenu = _a.setSubscriptionsMenu, videoProcessingEnabled = _a.videoProcessingEnabled, getUserFollowDataQuery = _a.getUserFollowDataQuery, isSubscriptionsMenuOpen = _a.isSubscriptionsMenuOpen, isRoleAdmin = _a.isRoleAdmin;
    var followedChannels = getUserFollowDataQuery && getUserFollowDataQuery.userFollowData && getUserFollowDataQuery.userFollowData.channels
        ? getUserFollowDataQuery.userFollowData.channels
        : [];
    var availableFollowedChannels = followingFeature && includes(followingFeature.activatedIn, tubeId)
        ? followedChannels
        : followedChannels.filter(function (channelId) { return includes(followingFeature.activatedIn, channelId); });
    var showSubscriptionPage = includes(followingFeature.activatedIn, tubeId) ||
        !!followedChannels.filter(function (channelId) { return includes(followingFeature.activatedIn, channelId); }).length;
    var channels = listChannelsQuery.channels
        ? listChannelsQuery.channels.filter(function (channel) { return includes(availableFollowedChannels, channel.id); })
        : [];
    var channelsToShow = channels && !isSubscriptionsMenuOpen ? channels.slice(0, 7) : channels;
    var showExpandMenu = channels && channels.length > 7;
    var expandedCount = channels ? channels.length - 7 : 0;
    var currentChannelParams = matchPath(currentPath, {
        strict: false,
        exact: false,
        path: '/channel/:id/home',
    });
    var channelIds = listTracksQuery && listTracksQuery.tracks ? uniq(listTracksQuery.tracks.map(function (track) { return track.channelId; })) : [];
    var channelsTracks = listChannelsQuery.channels
        ? listChannelsQuery.channels.filter(function (channel) { return includes(channelIds, channel.id); })
        : [];
    var followedTracks = getUserFollowDataQuery &&
        listTracksQuery &&
        listTracksQuery.tracks &&
        getUserFollowDataQuery.userFollowData &&
        getUserFollowDataQuery.userFollowData.tracks
        ? listTracksQuery.tracks
            .filter(function (track) { return includes(getUserFollowDataQuery.userFollowData.tracks || [], track.id); })
            .map(function (track) { return (__assign(__assign({}, track), { shouldShow: isLPUser, channelName: (channelsTracks.find(function (channel) { return channel.id === track.channelId; }) || {
                name: '',
            }).name })); })
        : [];
    var sideBarItems = __spreadArray(__spreadArray([
        {
            name: translate('support-chat'),
            icon: 'chat',
            linkTo: '/support/chat',
            id: 'support-chat-link',
            shouldShow: isChatFeatureEnabled,
            isSelected: currentPath === '/support/chat',
            isPage: true,
        },
        {
            name: translate('your-tasks'),
            icon: 'check_box',
            linkTo: '/tasks',
            id: 'tasks-link',
            shouldShow: isTasksFeatureEnabled,
            isSelected: currentPath === '/tasks',
            isPage: true,
        },
        {
            name: translate('notifications'),
            icon: 'notifications',
            linkTo: '/notifications',
            id: 'notifications-link',
            shouldShow: isNotificationsFeatureEnabled,
            isSelected: currentPath === '/notifications',
            isPage: true,
        },
        {
            name: translate('library'),
            icon: 'video_library',
            linkTo: '/library',
            id: 'library-link',
            shouldShow: isLPUser,
            isSelected: currentPath === '/library',
            isPage: true,
        },
        {
            name: translate('history'),
            icon: 'history',
            linkTo: '/history',
            id: 'history-link',
            shouldShow: true,
            isSelected: currentPath === '/history',
            isPage: true,
        },
        {
            name: translate('favorite'),
            icon: 'favorite',
            linkTo: '/favorites',
            id: 'favorites-link',
            shouldShow: isLPUser,
            isSelected: currentPath === '/favorites',
            isPage: true,
        }
    ], (followedTracks || [])), [
        {
            name: translate('embed-codes'),
            icon: 'screen_share',
            linkTo: '/sharings',
            id: 'sharings-link',
            shouldShow: isLPUser,
            isSelected: currentPath === '/sharings',
            isPage: true,
        },
        {
            name: translate('your-videos'),
            icon: 'ondemand_video',
            linkTo: '/my-videos',
            shouldShow: isLPUser,
            id: 'my-videos-link',
            isSelected: currentPath === '/my-videos',
            isPage: true,
        },
    ]);
    var logo = getTubeQuery.loading || getTubeQuery.error
        ? ''
        : getTubeQuery.tube.logo
            ? getTubeQuery.tube.logo
            : '/assets/images/logo.png';
    var sideBarItemsToShow = !isTracksMenuExpanded ? sideBarItems.slice(0, TRACKS_TO_SHOW_BEFORE_EXPAND) : sideBarItems;
    var showTracksExpandMenu = sideBarItems.length > TRACKS_TO_SHOW_BEFORE_EXPAND;
    var expandedTracksCount = sideBarItems.length ? sideBarItems.length - TRACKS_TO_SHOW_BEFORE_EXPAND : 0;
    return (
    // @ts-ignore
    React.createElement(List, { onClick: onPageChange, component: "div", style: { backgroundColor: 'white' }, className: classes.content },
        !isPersistent && (React.createElement("div", { className: classNames('flex items-center', classes.menuContainer) },
            React.createElement("div", { onClick: onCloseSidebar, className: classes.hamburgerWrapper },
                React.createElement(Icon, { className: classes.hamburger }, "menur")),
            React.createElement(Link, { id: "home-link", to: "/home" }, Boolean(logo) && React.createElement("img", { className: classes.logo, src: logo, alt: "logo" })))),
        React.createElement("div", { className: classes.topOptions },
            MenuItemWithIcon(translate('home'), 'home', '/home', 'home-link', currentPath === '/home', classes, tubeColor),
            isLPUser &&
                MenuItemWithIcon(translate('mandatory'), 'error_outline', '/mandatory', 'mandatory-link', currentPath === '/mandatory', classes, tubeColor),
            showSubscriptionPage &&
                !originalOrgId &&
                MenuItemWithIcon(translate('subscriptions'), 'subscriptions', '/subscriptions', 'my-tube-subscriptions-link', currentPath === '/subscriptions', classes, tubeColor)),
        (isLPUser || isTasksFeatureEnabled) && !originalOrgId && (React.createElement("div", { className: classes.groupSeparator },
            sideBarItemsToShow
                .filter(function (item) { return item.shouldShow; })
                .map(function (item) { return (React.createElement("span", { key: item.id }, item.isPage ? (React.createElement("span", { key: item.id }, MenuItemWithIcon(item.name, item.icon, item.linkTo, item.id, item.isSelected, classes, tubeColor))) : (React.createElement(Link, { key: item.id, name: item.name, id: "sharings-link", to: "/channel/" + item.channelId + "/playlists", className: classes.topNavItem },
                React.createElement(Icon, { className: classes.topNavImg }, "playlist_play"),
                React.createElement(Tooltip, { placement: "top", title: item.name },
                    React.createElement(Typography, { noWrap: true, className: classes.topNavText }, item.name)))))); }),
            !!showTracksExpandMenu && isLPUser && (React.createElement("div", { className: classes.showMoreButtonWrapper, onClick: function () { return setTracksExpandMenu(!isTracksMenuExpanded); } }, isTracksMenuExpanded ? (React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: classes.menuClass }, "keyboard_arrow_up"),
                React.createElement("span", { className: classes.menuText }, translate('showLess')))) : (React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: classes.menuClass }, "keyboard_arrow_down"),
                React.createElement("span", { className: classes.menuText },
                    "Show ",
                    expandedTracksCount,
                    " more"))))))),
        !!channelsToShow.length && (React.createElement("div", { className: classes.groupSeparator },
            React.createElement(ListSubheader, { disableSticky: true, className: classes.heading, component: "div" }, translate('subscriptions')),
            channelsToShow.map(function (channel) {
                return (React.createElement("span", { key: channel.id },
                    React.createElement(QueryS3Url, { source: channel.icon }, function (_a) {
                        var loading = _a.loading, error = _a.error, url = _a.url;
                        return (React.createElement(ListItem, { className: classNames(!!currentChannelParams &&
                                currentChannelParams.params &&
                                currentChannelParams.params.id === channel.id
                                ? classes.selectedChannelSubscriptionWrapper
                                : classes.channelSubscriptionWrapper), key: channel.id, button: true },
                            React.createElement(Link, { to: "/channel/" + channel.id + "/home", className: classNames(classes.subscriptionItem, classes.item), id: channel.name, name: channel.name },
                                loading ? (React.createElement(Avatar, { className: classes.channelPreloader })) : (React.createElement(React.Fragment, null, channel.name && url ? (React.createElement("img", { className: classes.channelImg, src: url })) : (React.createElement(Avatar, { style: {
                                        backgroundColor: tubeColor,
                                        color: 'white',
                                    }, className: classes.channelImg, src: url }, getInitials(channel.name))))),
                                React.createElement("span", { className: classes.channelText },
                                    " ",
                                    channel.name))));
                    })));
            }),
            showExpandMenu && (React.createElement("div", { className: classes.showMoreButtonWrapper, onClick: function () { return setSubscriptionsMenu(!isSubscriptionsMenuOpen); } }, isSubscriptionsMenuOpen ? (React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: classes.menuClass }, "keyboard_arrow_up"),
                React.createElement("span", { className: classes.menuText }, translate('showLess')))) : (React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: classes.menuClass }, "keyboard_arrow_down"),
                React.createElement("span", { className: classes.menuText },
                    "Show ",
                    expandedCount,
                    " more"))))))),
        isRoleAdmin && (listVideos || listUsers || listChannels || listTracks || listTags) && !originalOrgId && (React.createElement("div", { className: classes.groupSeparator },
            React.createElement(ListSubheader, { disableSticky: true, className: classNames(classes.heading, classes.headingPadding), component: "div" }, translate('content')),
            __spreadArray(__spreadArray(__spreadArray([
                {
                    id: 'admin-videos-link',
                    name: translate('videos'),
                    linkTo: '/admin/videos',
                    visible: isRoleAdmin && listVideos,
                    icon: 'ondemand_video',
                    isSelected: currentPath === '/admin/videos',
                },
                {
                    id: 'admin-users-link',
                    name: translate('users'),
                    linkTo: '/admin/users',
                    visible: listUsers,
                    icon: 'person_outline',
                    isSelected: currentPath === '/admin/users',
                },
                {
                    id: 'admin-channels-link',
                    name: translate('channels'),
                    linkTo: '/admin/channels',
                    visible: listChannels,
                    icon: 'apps',
                    isSelected: currentPath === '/admin/channels',
                },
                {
                    id: 'admin-tracks-link',
                    name: translate('tracks'),
                    linkTo: '/admin/playlists',
                    visible: listTracks,
                    icon: 'playlist_play',
                    isSelected: currentPath === '/admin/playlists',
                },
                {
                    id: 'tasks-link',
                    name: translate('tasks'),
                    linkTo: '/admin/tasks',
                    visible: listTracks,
                    icon: 'check_box',
                    isSelected: currentPath === '/admin/tasks',
                }
            ], (isLPUser &&
                (orgId === 'launchpeople' || orgId === 'trainingtube') && [
                {
                    id: 'tasks-link',
                    name: translate('operational-tasks'),
                    linkTo: '/admin/operationalTasks',
                    visible: listTracks,
                    icon: 'check_box',
                    isSelected: currentPath === '/admin/operationalTasks',
                },
            ])), [
                {
                    id: 'admin-tags-link',
                    name: translate('tags'),
                    linkTo: '/admin/tags',
                    visible: listTags,
                    icon: 'local_offer',
                    isSelected: currentPath === '/admin/tags',
                }
            ]), (isLPUser && [
                {
                    id: 'admin-users-usage-link',
                    name: translate('users-usage'),
                    linkTo: '/admin/users/usage',
                    visible: listUsers,
                    icon: 'data_usage',
                    isSelected: currentPath === '/admin/users/usage',
                },
            ])).filter(function (item) { return item.visible; })
                .map(function (item) { return (React.createElement("span", { key: item.id },
                ' ',
                MenuItemWithIcon(item.name, item.icon, item.linkTo, item.id, item.isSelected, classes, tubeColor))); }))),
        isRoleAdmin && (listVideos || listUsers || listChannels || listTracks || listTags) && !originalOrgId && (React.createElement("div", { className: classes.groupSeparator },
            React.createElement(ListSubheader, { disableSticky: true, className: classNames(classes.heading, classes.headingPadding), component: "div" }, translate('reports')),
            [
                {
                    id: 'admin-reports-link',
                    name: translate('dashboard'),
                    linkTo: '/admin/reports',
                    visible: listBranding,
                    icon: 'insert_chart',
                    isSelected: currentPath === '/admin/reports',
                },
                {
                    id: 'admin-shared-reports-link',
                    name: translate('share-reports'),
                    linkTo: '/admin/reports/shared',
                    visible: listBranding,
                    icon: 'table_chart',
                    isSelected: currentPath === '/admin/reports/shared',
                },
            ]
                .filter(function (item) { return item.visible; })
                .map(function (item) { return (React.createElement("span", { key: item.id }, MenuItemWithIcon(item.name, item.icon, item.linkTo, item.id, item.isSelected, classes, tubeColor))); }))),
        (listBranding || listAzureAd || listClassification) && !originalOrgId && (React.createElement("div", { className: classNames(classes.mobileHidden, classes.groupSeparator) },
            React.createElement(ListSubheader, { disableSticky: true, className: classNames(classes.heading, classes.headingPadding), component: "div" }, translate('configuration')),
            __spreadArray([
                {
                    id: 'admin-branding-link',
                    name: translate('branding'),
                    linkTo: '/admin/branding',
                    visible: listBranding,
                },
                {
                    id: 'azure-ad-config-link',
                    name: translate('azure-ad-config'),
                    linkTo: '/admin/azure-ad',
                    visible: listAzureAd,
                },
                {
                    id: 'information-classification-link',
                    name: translate('information-classification'),
                    linkTo: '/admin/information-classification',
                    visible: listClassification,
                },
                {
                    id: 'security-link',
                    name: translate('security'),
                    linkTo: '/admin/security',
                    visible: listBranding,
                }
            ], (isLPUser && [
                {
                    id: 'admin-organization-link',
                    name: translate('organization'),
                    linkTo: '/admin/organization',
                    visible: listBranding,
                },
            ])).filter(function (item) { return item.visible; })
                .map(function (item) { return (React.createElement(Item, { key: item.name, classes: classes, item: item, translate: translate, isBeta: false })); }))),
        updateOrganization && isLPUser && !originalOrgId && (React.createElement("div", { style: orgId !== 'launchpeople' ? { marginBottom: 50 } : {}, className: classNames(classes.mobileHidden, classes.groupSeparator) },
            React.createElement(ListSubheader, { disableSticky: true, className: classNames(classes.heading, classes.headingPadding), component: "div" }, translate('finance')),
            [
                {
                    id: 'features-services-link',
                    name: translate('features-services'),
                    linkTo: '/finance/features-services',
                    visible: true,
                },
                // {
                //   id: 'internal-users-link',
                //   name: translate('internal-users'),
                //   linkTo: '/finance/internal-users',
                //   visible: true,
                // },
                // {
                //   id: 'external-users-link',
                //   name: translate('external-users'),
                //   linkTo: '/finance/external-users',
                //   visible: true,
                // },
                // {
                //   id: 'video-rendering-link',
                //   name: translate('video-rendering'),
                //   linkTo: '/finance/video-rendering',
                //   visible: videoProcessingEnabled,
                //   isBeta: videoProcessingBeta,
                // },
                // {
                //   id: 'anonymous-plays-link',
                //   name: translate('anonymous-plays'),
                //   linkTo: '/finance/anonymous-plays',
                //   visible: true,
                // },
            ]
                .filter(function (item) { return item.visible; })
                .map(function (item) { return (React.createElement(Item, { key: item.name, classes: classes, item: item, translate: translate, isBeta: false })); }))),
        updateOrganization && isLPUser && orgId === 'launchpeople' && (React.createElement("div", { style: { marginBottom: 50 }, className: classNames(classes.mobileHidden, classes.groupSeparator) },
            React.createElement(ListSubheader, { disableSticky: true, className: classNames(classes.heading, classes.headingPadding), component: "div" }, "Trainingtube Network"),
            [
                {
                    id: 'orgs',
                    name: 'Organizations',
                    linkTo: '/orgs',
                    visible: true,
                },
                {
                    id: 'orgs',
                    name: 'Activity',
                    linkTo: '/orgs/usage',
                    visible: true,
                },
                {
                    id: 'usercrm',
                    name: 'User CRM',
                    linkTo: '/orgs/crm',
                    visible: true,
                },
            ]
                .filter(function (item) { return item.visible; })
                .map(function (item) { return (React.createElement(Item, { key: item.name, classes: classes, item: item, translate: translate, isBeta: false })); })))));
};
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.openSidebar = function () {
            _this.props.toggleSidebar(true);
        };
        _this.setSubscriptionsMenu = function (value) {
            _this.setState({ isSubscriptionsMenuOpen: value });
        };
        _this.closeSidebar = function (event) {
            event.stopPropagation();
            _this.props.toggleSidebar(false);
        };
        return _this;
    }
    Sidebar.prototype.componentDidMount = function () {
        var scrollMenu = document.getElementById('side-scroll-menu');
        if (!!scrollMenu) {
            scrollMenu.scrollTop = this.props.scrollPosition;
        }
        // pages
        var isHomePage = window.location.pathname === '/home';
        var isMandatoryPage = window.location.pathname === '/mandatory';
        var isSearchPage = window.location.pathname === '/results';
        var isSubsriptionPage = window.location.pathname === '/subscriptions';
        var isHistoryPage = window.location.pathname === '/history';
        var isLibraryPage = window.location.pathname === '/library';
        var isFavouritePage = window.location.pathname === '/favorites';
        var isSharingPage = window.location.pathname === '/sharings';
        var isMyVideospage = window.location.pathname === '/my-videos';
        var isAdminPage = includes(window.location.pathname, '/admin');
        var isFinancePage = includes(window.location.pathname, '/finance');
        var isTaskPage = isCurrentPageAdminOrUserTasksPage();
        var isNotificationPage = isCurrentPageNotificationPage();
        if ((this.props.sidebarStatus &&
            !isHomePage &&
            !isSearchPage &&
            !isTaskPage &&
            !isNotificationPage &&
            !isSubsriptionPage &&
            !isHistoryPage &&
            !isLibraryPage &&
            !isFavouritePage &&
            !isSharingPage &&
            !isMyVideospage &&
            !isAdminPage &&
            !isFinancePage &&
            !isMandatoryPage) ||
            (!this.props.sidebarStatus &&
                (isHomePage ||
                    isSearchPage ||
                    isTaskPage ||
                    isNotificationPage ||
                    isHistoryPage ||
                    isMandatoryPage ||
                    isLibraryPage ||
                    isFavouritePage ||
                    isSharingPage ||
                    isMyVideospage ||
                    isFinancePage ||
                    isAdminPage ||
                    isSubsriptionPage))) {
            this.props.toggleSidebar(!this.props.sidebarStatus);
        }
    };
    Sidebar.prototype.render = function () {
        var _this = this;
        var _a = this.props, tubeId = _a.tubeId, classes = _a.classes, listTags = _a.listTags, isLPUser = _a.isLPUser, orgId = _a.orgId, listUsers = _a.listUsers, translate = _a.translate, tubeColor = _a.tubeColor, listVideos = _a.listVideos, listTracks = _a.listTracks, followBeta = _a.followBeta, isPersistent = _a.isPersistent, listAzureAd = _a.listAzureAd, currentPath = _a.currentPath, listChannels = _a.listChannels, originalOrgId = _a.originalOrgId, getTubeQuery = _a.getTubeQuery, listBranding = _a.listBranding, sidebarStatus = _a.sidebarStatus, listTracksQuery = _a.listTracksQuery, listChannelsQuery = _a.listChannelsQuery, followingFeature = _a.followingFeature, areTracksExpanded = _a.areTracksExpanded, updateOrganization = _a.updateOrganization, listClassification = _a.listClassification, videoProcessingBeta = _a.videoProcessingBeta, expandSubscriptions = _a.expandSubscriptions, isTasksFeatureEnabled = _a.isTasksFeatureEnabled, isChatFeatureEnabled = _a.isChatFeatureEnabled, videoProcessingEnabled = _a.videoProcessingEnabled, getUserFollowDataQuery = _a.getUserFollowDataQuery, toggleTracksExpandMenu = _a.toggleTracksExpandMenu, toggleSubscriptionsMenu = _a.toggleSubscriptionsMenu, isNotificationsFeatureEnabled = _a.isNotificationsFeatureEnabled, isRoleAdmin = _a.isRoleAdmin;
        return (React.createElement(Drawer, { PaperProps: {
                style: {
                    backgroundColor: tubeColor,
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    marginTop: isPersistent ? (originalOrgId ? 90 : 60) : 0,
                    zIndex: 3,
                },
            }, className: classes.drawer, variant: isPersistent ? 'persistent' : 'temporary', open: sidebarStatus, onClose: function () { return _this.props.toggleSidebar(false); }, transitionDuration: 100 },
            React.createElement("aside", { id: "side-scroll-menu", style: { backgroundColor: 'white', width: SIDEBAR_WIDTH }, className: classes.sidebar, onClick: this.openSidebar },
                React.createElement(Content, { isLPUser: isLPUser, tubeId: tubeId, classes: classes, getTubeQuery: getTubeQuery, followingFeature: followingFeature, onPageChange: function () {
                        var scrollMenu = document.getElementById('side-scroll-menu');
                        _this.props.updateScrollPosition(scrollMenu.scrollTop);
                    }, listTags: listTags, listUsers: listUsers, translate: translate, tubeColor: tubeColor, isPersistent: isPersistent, listVideos: listVideos, listTracks: listTracks, followBeta: followBeta, listAzureAd: listAzureAd, currentPath: currentPath, originalOrgId: originalOrgId, orgId: orgId, listChannels: listChannels, listBranding: listBranding, listTracksQuery: listTracksQuery, listChannelsQuery: listChannelsQuery, onCloseSidebar: this.closeSidebar, isTasksFeatureEnabled: isTasksFeatureEnabled, setTracksExpandMenu: toggleTracksExpandMenu, listClassification: listClassification, updateOrganization: updateOrganization, videoProcessingBeta: videoProcessingBeta, isSubscriptionsMenuOpen: expandSubscriptions, isTracksMenuExpanded: areTracksExpanded, setSubscriptionsMenu: toggleSubscriptionsMenu, getUserFollowDataQuery: getUserFollowDataQuery, videoProcessingEnabled: videoProcessingEnabled, isChatFeatureEnabled: isChatFeatureEnabled, isNotificationsFeatureEnabled: isNotificationsFeatureEnabled, isRoleAdmin: isRoleAdmin }))));
    };
    return Sidebar;
}(React.PureComponent));
function mapDispatchToProps(dispatch, ownProps) {
    return bindActionCreators({
        toggleSidebar: toggleSidebar,
        toggleSubscriptionsMenu: toggleSubscriptionsMenu,
        toggleTracksExpandMenu: toggleTracksExpandMenu,
        updateScrollPosition: updateScrollPosition,
    }, dispatch);
}
function mapStateToProps(state, ownProps) {
    var _a, _b;
    var followingFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'following'; });
    var infClassificationFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'infClassification'; });
    var tagsFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'tags'; });
    var videoProcessingFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'videoProcessing'; });
    return __assign(__assign({}, ownProps), { sidebarStatus: state.sidebar.status, areTracksExpanded: state.sidebar.areTracksExpanded, expandSubscriptions: state.sidebar.expandSubscriptions, originalOrgId: state.auth.user.originalOrgId, scrollPosition: state.sidebar.scrollPosition, listUsers: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateOrganization), updateOrganization: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateOrganization), listVideos: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.readVideo), listChannels: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateOrganization), listTracks: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateOrganization), listTags: Boolean(state.auth.user.permissions) &&
            Boolean(state.auth.user.permissions.updateOrganization) &&
            tagsFeature &&
            Boolean(tagsFeature.activatedIn.length), listBranding: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateOrganization), listAzureAd: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.updateAzureAdCertificate), listClassification: Boolean(state.auth.user.permissions) &&
            Boolean(state.auth.user.permissions.updateInformationClassification) &&
            infClassificationFeature &&
            Boolean(infClassificationFeature.activatedIn.length), translate: getTranslation(state.translation.lang), orgId: state.auth.organization.id, tubeId: state.auth.tube.id, followBeta: followingFeature && followingFeature.status === 'beta', videoProcessingEnabled: videoProcessingFeature && Boolean(videoProcessingFeature.activatedIn.length), videoProcessingBeta: videoProcessingFeature && videoProcessingFeature.status === 'beta', tubeColor: state.auth.tube.color, isTasksFeatureEnabled: isTasksFeatureEnabled(state, ''), isChatFeatureEnabled: isChatFeatureEnabled(state, ''), isNotificationsFeatureEnabled: isNotificationsFeatureEnabled(state), followingFeature: followingFeature, isLPUser: isLPUser(state.auth.user.email), isRoleAdmin: ((_b = (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.role) === 'admin' });
}
var sidebar = function (props) {
    // @ts-ignore
    var Comp = withStyles(styles)(compose(connect(mapStateToProps, mapDispatchToProps), listChannelsData('readChannel'), listTracksData(), getTubeData(), getUserFollowData())(Sidebar));
    return React.createElement(Comp, __assign({}, props));
};
export default sidebar;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/Sidebar.tsx
// module id = 1437
// module chunks = 81